/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const GET_HEADER_DATES = 'GET_HEADER_DATES';
export const GET_EXPORTED_MENUS = 'GET_EXPORTED_MENUS';
